module.exports = __webpack_public_path__ + "static/media/leaf-oak.27d57427.svg";